<div class="edu-page" [class.pseucode-navbar]="this.currentRoute?.name == 'Pseudocode'">
  <div class="navbar top-pad" [class.dark-mode]='this.isDark'
    [class.navbar-collapsed]="this.currentRoute?.name == 'Pseudocode'" [class.hide]="!this.sideNavOpen">
    <edu-logo class="logo" [collapsed]="this.currentRoute?.name == 'Pseudocode'"></edu-logo>
    <div class="routes" [class.collapsed-routes]="this.currentRoute?.name == 'Pseudocode'">
      @for (route of routes; track route) {
        <app-navbar-item [collapsed]="this.currentRoute?.name == 'Pseudocode' || !this.sideNavOpen"
        [route]="route"></app-navbar-item>
      }
    </div>
  </div>
  <div class="background">
    <!-- <app-ramadan-header class="no-padding"></app-ramadan-header> -->
    <div class="header top-pad" [class.dark-mode]='this.isDark'>
      <button class="nav-button" mat-icon-button (click)="this.toggleSideNav()"><mat-icon>menu</mat-icon></button>
      @if (this.currentRoute != null) {
        <edu-header-title [darkMode]="this.isDark"
        [route]="this.currentRoute"></edu-header-title>
      }
      <div class="profile-button-container">
        <!-- <edu-points-summary [darkMode]="this.isDark" *ngIf="this.environment.org == 'ICTeam'"
      type="points"></edu-points-summary>
      <edu-points-summary [darkMode]="this.isDark" *ngIf="this.environment.org == 'CSTeam'"
      type="trophy"></edu-points-summary> -->
      <profile-button></profile-button>
    </div>
  </div>
  <div class="actual-page" (click)="this.toggleSideNav(false)"
    [class.translator]="this.currentRoute?.name == 'Pseudocode'" [class.dark-mode]="isDark"
    [class.actual-submission]="checkPage()">
    <router-outlet></router-outlet>
  </div>
</div>
</div>
